import { BaseStore } from "stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import { api_get } from "api/utils"


export type LoreType = {
    key: string;
    uuid: string;
    slug: string;
    content: string;
    date_created: string;
    date_updated: string;
    updateProps?: (attributes: LoreType) => void;
};

// Domain object Lore
export class Lore implements LoreType {
    key = "";
    uuid = "";
    slug = "";
    content = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: LoreType) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: LoreType) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class LoreStore extends BaseStore<LoreType, Lore> {


    FETCHED_SLUGS = [] as string[];

    async fetchBySlug(identity: string, slug: string): Promise<LoreType | null>  {
        const params = { identity: identity || '', slug };
        if(this.FETCHED_SLUGS.includes(slug)) {
            return null;
        }
        this.FETCHED_SLUGS.push(slug);

        const url = (slug.startsWith('public') || slug.startsWith('feature'))
            ? '/lore/by-public-slug'
            : '/lore/by-slug';
        const response = await api_get(url, params);

        if (response.ok) {
            const data = await response.json();
            this.receiveUpdate(data);
            return data;
        }
        else {
            console.error("error fetching lore", response);
            throw new Error("Failed to fetch lore");
        }

    };


    modelConstructor() {
        return Lore;
    }

}
